import { render, staticRenderFns } from "./regFinish.vue?vue&type=template&id=e3b795ae&scoped=true&"
import script from "./regFinish.vue?vue&type=script&lang=js&"
export * from "./regFinish.vue?vue&type=script&lang=js&"
import style0 from "./regFinish.vue?vue&type=style&index=0&id=e3b795ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b795ae",
  null
  
)

export default component.exports